export const workPreferencesOptions = ['Full Time', 'Part Time', 'Hourly'];
